import { render, staticRenderFns } from "./agenturen-dubletten-confirmation-view.vue?vue&type=template&id=3870031a"
import script from "./agenturen-dubletten-confirmation-view.vue?vue&type=script&lang=js"
export * from "./agenturen-dubletten-confirmation-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports